import { render, staticRenderFns } from "./Form.Mercadoria.vue?vue&type=template&id=b5cfbf3a"
import script from "./Form.Mercadoria.vue?vue&type=script&lang=js"
export * from "./Form.Mercadoria.vue?vue&type=script&lang=js"
import style0 from "./Form.Mercadoria.vue?vue&type=style&index=0&id=b5cfbf3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports